import _ from "lodash";
import errorDecorator from "@/components/fields/errors";

export default {
  mixins: [errorDecorator],

  methods: {
    getPracticeOptions(practices) {
      const mainAccounts = _.filter(
        practices,
        p => !p.attributes.parentId && p.attributes.subdomain !== "public"
      );
      const practiceOptions = Object.values(mainAccounts).map(p => {
        const option = { value: p.id, label: p.attributes.name };
        return option;
      });

      return practiceOptions;
    },

    setTimezones() {
      const index = _.findIndex(this.fields, ["key", "timezone"]);
      const timezones = this.$store.getters["practice/getTimezones"];
      const zones = [];
      _.forEach(timezones, zone => {
        zones.push({
          value: zone.name,
          label: `(GMT${zone.offset}) ${zone.name}`
        });
      });
      this.fields[index].options = zones;
    }
  },

  data() {
    return {
      form: {},
      fields: [
        {
          key: "parentId",
          type: "select",
          options: [{ value: "", label: "Self" }],
          templateOptions: {
            label: "Parent Account"
          },
          required: true
        },
        {
          key: "name",
          type: "input",
          templateOptions: {
            label: "Name"
          },
          required: true
        },
        {
          key: "customerId",
          type: "input",
          templateOptions: {
            label: "Customer Id"
          },
          required: true
        },
        {
          key: "subdomain",
          type: "input",
          templateOptions: {
            label: "Subdomain",
            atts: { maxlength: 20 }
          },
          required: true
        },
        {
          key: "statementDescriptor",
          type: "input",
          templateOptions: {
            label: "Credit Card Statement Descriptor",
            atts: { maxlength: 22 }
          },
          required: true
        },
        {
          key: "productTable",
          type: "productTable",
          templateOptions: {
            label: "Product Table"
          },
          required: true
        },
        {
          key: "timezone",
          type: "select",
          options: [],
          templateOptions: {
            label: "Timezone"
          },
          required: true
        },
        {
          key: "websiteUrl",
          type: "input",
          templateOptions: {
            label: "Website Url",
            inputType: "url"
          },
          required: true
        },
        {
          key: "phone",
          type: "input",
          templateOptions: {
            label: "Phone",
            inputType: "tel"
          },
          required: true
        },
        {
          key: "address",
          type: "input",
          templateOptions: {
            label: "Address"
          },
          required: true
        },
        {
          key: "primaryColor",
          type: "color",
          templateOptions: {
            label: "Primary Color"
          },
          required: true
        },
        {
          key: "secondaryColor",
          type: "color",
          templateOptions: {
            label: "Secondary Color"
          },
          required: true
        },
        {
          key: "virtualVisitEnabled",
          type: "select",
          options: [
            { value: "true", label: "Yes" },
            { value: "false", label: "No" }
          ],
          templateOptions: {
            label: "Virtual Visit Enabled"
          },
          required: true
        },
        {
          key: "twilioPhoneNumber",
          type: "input",
          templateOptions: {
            label: "Twilio Phone Number"
          },
          required: false
        },
        {
          key: "visuwellPartnerToken",
          type: "input",
          templateOptions: {
            label: "Visuwell Partner Token"
          },
          required: true
        }
      ]
    };
  }
};
